import { type VmetaProjectOwner } from "common";
import { useAuth } from "@via/hooks/useAuth";

type IsVmetaCanvasOwnerParams = {
  owner: VmetaProjectOwner | undefined;
  userId?: string;
  username?: string;
};

const isVmetaCanvasOwner = ({
  owner,
  userId,
  username,
}: IsVmetaCanvasOwnerParams): boolean => {
  if (userId && typeof owner === "object" && owner?._id === userId) {
    return true;
  }

  if (!username) {
    return false;
  }

  if (typeof owner === "string") {
    return owner === username;
  }

  return owner?.username === username;
};

export const useVmetaCanvasOwner = (
  owner: VmetaProjectOwner | undefined
): boolean => {
  const { user } = useAuth();

  return isVmetaCanvasOwner({
    owner,
    userId: user?.vmeta?.userId,
    username: user?.username,
  });
};
